export function formatBytes(bytes, decimals = 1) {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "—";
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  const value = bytes / Math.pow(k, i);
  return `${i === 0 ? value : value.toFixed(decimals)} ${sizes[i]}`;
}

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", ...opts });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function timeUntil(iso) {
  if (!iso) return "Never expires";
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return "Expired";
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `Expires in ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `Expires in ${hours} h`;
  return `Expires in ${Math.floor(hours / 24)} days`;
}

export const EXPIRATION_LABELS = { "1d": "1 Day", "7d": "7 Days", "1m": "1 Month", unlimited: "Unlimited" };

export function formatSpeed(bps) {
  if (!bps || !isFinite(bps)) return "";
  return `${formatBytes(bps)}/s`;
}

export function formatEta(seconds) {
  if (!seconds || !isFinite(seconds)) return "";
  if (seconds < 60) return `${Math.ceil(seconds)}s left`;
  return `${Math.ceil(seconds / 60)} min left`;
}

export function pct(used, total) {
  if (!total) return 0;
  return Math.min(100, Math.round((used / total) * 100));
}
